import { Link, NavLink, Outlet } from 'react-router-dom';
import logo from '../../assets/logo.png';
import { useSiteAuth } from '../hooks/useSiteAuth';
import { useEventManager } from '../hooks/useEventManager';
import { getSiteRoleLabel } from '../data/siteUsers';

export default function PortalLayout() {
  const { session, signOut } = useSiteAuth();
  const { featuredEvent } = useEventManager();

  if (!session) {
    return null;
  }

  const portalNavLinks = [
    { path: '/portal', label: 'Overview', end: true },
    { path: '/portal/events', label: 'Events' },
    ...(session.role === 'admin' || session.role === 'board_member'
      ? [{ path: '/portal/board', label: 'Board Bios' }]
      : []),
    ...(session.role === 'admin'
      ? [
          { path: '/portal/models', label: 'Models' },
          { path: '/portal/orders', label: 'Orders' },
        ]
      : []),
    { path: '/portal/account', label: 'Account' },
  ];

  return (
    <div className="portal-shell">
      <header className="portal-topbar">
        <div className="portal-topbar-inner">
          <Link to="/" className="portal-brand" aria-label="Return to Victoria's Place public site">
            <span className="portal-brand-mark">
              <img src={logo} alt="" className="portal-brand-logo" />
            </span>
            <span>
              <strong>Victoria&apos;s Place</strong>
              <span>Site portal</span>
            </span>
          </Link>

          <div className="portal-topbar-meta">
            <span className="portal-role-badge">{getSiteRoleLabel(session.role)}</span>
            <div className="portal-user-identity">
              <strong>{session.name}</strong>
              <span>{session.email}</span>
            </div>
            <Link to="/" className="portal-topbar-link">
              Public site
            </Link>
            <button type="button" onClick={signOut} className="portal-signout-button">
              Sign out
            </button>
          </div>
        </div>
      </header>

      <div className="portal-frame">
        <aside className="portal-sidebar">
          <div className="portal-sidebar-block">
            <p className="portal-sidebar-kicker">Navigation</p>
            <nav className="portal-nav" aria-label="Portal navigation">
              {portalNavLinks.map((link) => (
                <NavLink
                  key={link.path}
                  to={link.path}
                  end={link.end}
                  className={({ isActive }) =>
                    `portal-nav-link ${isActive ? 'portal-nav-link--active' : ''}`
                  }
                >
                  {link.label}
                </NavLink>
              ))}
            </nav>
          </div>

          <div className="portal-sidebar-block portal-sidebar-block--feature">
            <p className="portal-sidebar-kicker">Featured event</p>
            {featuredEvent ? (
              <>
                <h2>{featuredEvent.title}</h2>
                <p>{featuredEvent.dateLabel}</p>
                <span>{featuredEvent.locationName}</span>
              </>
            ) : (
              <>
                <h2>No event is published yet.</h2>
                <p>The admin workspace can create and publish the first event.</p>
              </>
            )}
          </div>
        </aside>

        <main className="portal-workspace">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
